import { Tabs, TabsProps } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useFeatureToggles } from '../../context/featureToggles';
import { Permission } from '../../user/types/Permission';
import { useUser } from '../../user/userContext';
import { userHasPermission } from '../../user/userUtils';
import { BookingOrderFilterCategory } from '../views/BookingOrders';

type BookingOrderFilterProps = {
  defaultTab: string;
  onTabChange: (key: BookingOrderFilterCategory) => void;
};

const BookingOrderFilterTabs: React.FC<BookingOrderFilterProps> = ({
  defaultTab,
  onTabChange,
}) => {
  const [currentUser] = useUser();
  const { t } = useTranslation();
  const { isOpenClassesEnabled } = useFeatureToggles();

  const showOpenClassOrders =
    isOpenClassesEnabled &&
    userHasPermission(currentUser, Permission.COURSE_INSTANCE_READ_LIST);

  const tabItems: TabsProps['items'] = [
    {
      key: BookingOrderFilterCategory.Ordered,
      label: t('bookingOrderStatus.ordered'),
    },
    {
      key: BookingOrderFilterCategory.Preliminary,
      label: t('bookingOrderStatus.preliminary'),
    },
    {
      key: BookingOrderFilterCategory.Confirmed,
      label: t('bookingOrderStatus.confirmed'),
    },
    {
      key: BookingOrderFilterCategory.Canceled,
      label: t('bookingOrderStatus.canceled'),
    },
    {
      key: BookingOrderFilterCategory.Urgent,
      label: t('components.BookingOrderFilterPicker.urgent'),
    },
    {
      key: BookingOrderFilterCategory.All,
      label: t('components.BookingOrderFilterPicker.all'),
    },
    ...(showOpenClassOrders
      ? [
          {
            key: BookingOrderFilterCategory.OpenClassOrders,
            label: t('views.BookingOrders.openClassOrders'),
          },
        ]
      : []),
  ];

  return (
    <Tabs
      defaultActiveKey={defaultTab}
      items={tabItems}
      onChange={(activeKey) =>
        onTabChange(activeKey as BookingOrderFilterCategory)
      }
    />
  );
};

export default BookingOrderFilterTabs;
